module.exports = __webpack_public_path__ + "img/yamamah.d42e163b.png";